<template>
  <form v-if="form" @submit.prevent="submit" @keydown="form.onKeydown($event)">
    <alert-error
      v-if="form.errors.get('message')"
      :form="form"
      :message="form.errors.get('message')"
    ></alert-error>
    <div class="row">
      <div class="col-md-12">
        <div class="row">
          <div class="col-md-12">
            <div class="card">
              <div class="card-body mb-n2">
                <div
                  class="row d-flex justify-content-center align-items-center"
                >
                  <div class="col-md-6 col-lg-4">
                    <div class="form-group">
                      <label for="employe"
                        >Employé <span class="text-danger ml-1">*</span>
                      </label>
                      <v-custom-select
                        label="nom"
                        id="employe"
                        :options="emps"
                        :reduce="(employe) => employe.uuid"
                        v-model="form.employe"
                        placeholder="Employé"
                      >
                        <template v-slot:option="{ nom }">
                          <h5 style="margin: 0">{{ nom }}</h5>
                        </template>
                        <template #no-options> Aucune données </template>
                        <template #search="{ attributes, events }">
                          <input
                            class="custom-select-height vs__search"
                            v-bind="attributes"
                            v-on="events"
                          />
                        </template>
                      </v-custom-select>
                      <input
                        type="hidden"
                        class="form-control"
                        :class="{
                          'is-invalid': form.errors.has('employe'),
                        }"
                      />
                      <has-error :form="form" field="employe"></has-error>
                    </div>
                  </div>

                  <div class="col-md-6 col-lg-4">
                    <div class="form-group">
                      <label for="type_absence"
                        >Type absence <span class="text-danger">*</span></label
                      >
                      <v-custom-select
                        label="nom"
                        id="type_absence"
                        :options="type_absences"
                        :reduce="(type_absence) => type_absence.uuid"
                        v-model="form.type_absence"
                        placeholder="Type absence"
                      >
                        <template v-slot:option="{ nom }">
                          <h5 style="margin: 0">{{ nom }}</h5>
                        </template>
                        <template #no-options> Aucune données </template>
                        <template #search="{ attributes, events }">
                          <input
                            class="custom-select-height vs__search"
                            v-bind="attributes"
                            v-on="events"
                          />
                        </template>
                      </v-custom-select>
                      <input
                        type="hidden"
                        class="form-control"
                        :class="{
                          'is-invalid': form.errors.has('type_absence'),
                        }"
                      />
                      <has-error :form="form" field="type_absence"></has-error>
                    </div>
                  </div>
                  <div class="col-md-6 col-lg-4">
                    <div class="form-group">
                      <label for="remplacant">Remplaçant </label>
                      <v-custom-select
                        label="nom"
                        id="remplacant"
                        :options="remps"
                        :reduce="(remplacant) => remplacant.uuid"
                        v-model="form.remplacant"
                        placeholder="Remplaçant"
                      >
                        <template v-slot:option="{ nom }">
                          <h5 style="margin: 0">{{ nom }}</h5>
                        </template>
                        <template #no-options> Aucune données </template>
                        <template #search="{ attributes, events }">
                          <input
                            class="custom-select-height vs__search"
                            v-bind="attributes"
                            v-on="events"
                          />
                        </template>
                      </v-custom-select>
                      <input
                        type="hidden"
                        class="form-control"
                        :class="{
                          'is-invalid': form.errors.has('remplacant'),
                        }"
                      />
                      <has-error :form="form" field="remplacant"></has-error>
                    </div>
                  </div>

                  <div class="col-md-3 col-lg-2">
                    <div class="form-group">
                      <label for="date_debut"
                        >Date debut <span class="text-danger">*</span></label
                      >
                      <date-picker
                        v-model="form.date_debut"
                        name="date_debut"
                        placeholder="Date"
                        lang="fr"
                        format="DD/MM/YYYY"
                        value-type="DD/MM/YYYY"
                      ></date-picker>
                      <input
                        class="form-control"
                        :class="{
                          'is-invalid': form.errors.has('date_debut'),
                        }"
                        type="hidden"
                      />
                      <has-error :form="form" field="date_debut"></has-error>
                    </div>
                  </div>

                  <div class="col-md-3 col-lg-2">
                    <div class="form-group">
                      <label for="date_fin"
                        >Date fin <span class="text-danger">*</span></label
                      >
                      <date-picker
                        v-model="form.date_fin"
                        name="date_fin"
                        placeholder="Date"
                        lang="fr"
                        format="DD/MM/YYYY"
                        value-type="DD/MM/YYYY"
                      ></date-picker>
                      <input
                        class="form-control"
                        :class="{
                          'is-invalid': form.errors.has('date_fin'),
                        }"
                        type="hidden"
                      />
                      <has-error :form="form" field="date_fin"></has-error>
                    </div>
                  </div>

                  <div class="col-md-6 col-lg-4">
                    <div class="form-group">
                      <label for="type_contrat"
                        >Type Contrat <span class="text-danger">*</span></label
                      >
                      <v-custom-select
                        label="nom"
                        id="type_contrat"
                        :options="type_contrats"
                        :reduce="(type_contrat) => type_contrat.uuid"
                        v-model="form.type_contrat"
                        placeholder="Type de contrat"
                      >
                        <template v-slot:option="{ nom }">
                          <h5 style="margin: 0">{{ nom }}</h5>
                        </template>
                        <template #no-options> Aucune données </template>
                        <template #search="{ attributes, events }">
                          <input
                            class="custom-select-height vs__search"
                            v-bind="attributes"
                            v-on="events"
                          />
                        </template>
                      </v-custom-select>
                      <input
                        type="hidden"
                        class="form-control"
                        :class="{
                          'is-invalid': form.errors.has('type_contrat'),
                        }"
                      />
                      <has-error :form="form" field="type_contrat"></has-error>
                    </div>
                  </div>

                  <div class="col-md-6 col-lg-4">
                    <div class="form-group">
                      <label for="nature_poste">Poste </label>
                      <v-custom-select
                        label="nom"
                        id="nature_poste"
                        :options="nature_postes"
                        :reduce="(nature_poste) => nature_poste.uuid"
                        v-model="form.poste"
                        placeholder="Choisir le poste"
                      >
                        <template v-slot:option="{ nom }">
                          <h5 style="margin: 0">{{ nom }}</h5>
                        </template>
                        <template #no-options> Aucune données </template>
                        <template #search="{ attributes, events }">
                          <input
                            class="custom-select-height vs__search"
                            v-bind="attributes"
                            v-on="events"
                          />
                        </template>
                      </v-custom-select>
                      <input
                        type="hidden"
                        class="form-control"
                        :class="{
                          'is-invalid': form.errors.has('poste'),
                        }"
                      />
                      <has-error :form="form" field="poste"></has-error>
                    </div>
                  </div>

                  <div class="col-md-12 col-lg-12 mt-n1">
                    <div class="form-group">
                      <label for="commentaire">Commentaire </label>
                      <textarea
                        class="form-control"
                        :class="{
                          'is-invalid': form.errors.has('commentaire'),
                        }"
                        id="commentaire"
                        v-model="form.commentaire"
                        type="text"
                        placeholder="Commentaire"
                        maxlength="100"
                      ></textarea>
                      <has-error :form="form" field="commentaire"></has-error>
                    </div>
                  </div>

                  <div class="col-md-10 col-lg-8 mt-n1">
                    <div class="form-group">
                      <label for="chantier">Chantiers </label>
                      <multiselect
                        id="chantier"
                        v-model="selectedChantiers"
                        :options="chantiers"
                        :multiple="true"
                        :hideSelected="true"
                        :close-on-select="false"
                        :clear-on-select="false"
                        :preserve-search="true"
                        selectLabel="Tapez Entrez pour selectionner"
                        placeholder="Choisir les chantiers"
                        label="nom"
                        track-by="id"
                        :disabled="form.all"
                      >
                        <template slot="option" slot-scope="{ option }">
                          <div class="d-flex flex-column mb-2">
                            <span class="h6 font-weight-bold mb-1">
                              {{ option.nom }}
                            </span>
                          </div>
                        </template>
                      </multiselect>
                    </div>
                  </div>
                  <div class="col-md-2 col-lg-4 mt-n1 mt-lg-0">
                    <div class="custom-control custom-checkbox">
                      <input
                        type="checkbox"
                        class="custom-control-input"
                        id="allChantiers"
                        v-model="form.all"
                      />
                      <label class="custom-control-label" for="allChantiers"
                        >Tous les chantiers</label
                      >
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row mt-2 mb-4">
      <div class="col-md-12 text-right">
        <button
          type="button"
          class="btn btn-secondary mr-4"
          @click.prevent="list"
          v-if="!edit"
        >
          Liste des remplacements
        </button>

        <ButtonLoader
          :busy="form.busy"
          type="submit"
          customClass="btn btn-custom-primary w-40"
          loadText="Traitement en cours..."
          :Text="edit ? 'Enrégistrer' : 'Créer'"
          style="min-width: 100px"
        ></ButtonLoader>
      </div>
    </div>
  </form>
</template>

<script>
import DatePicker from 'vue2-datepicker';
// import { VueEditor } from 'vue2-editor';
// import VueEditorToolbar from '@/vue-editor-tool-bar';

export default {
  props: {
    propForm: {
      type: Object,
      required: true,
    },
    edit: {
      type: Boolean,
      default: false,
    },
    commerciaux: {
      type: Array,
      default() {
        return [];
      },
    },
    employes: {
      type: Array,
      default() {
        return [];
      },
    },
    chantiers: {
      type: Array,
      default() {
        return [];
      },
    },
    type_absences: {
      type: Array,
      default() {
        return [];
      },
    },
    type_contrats: {
      type: Array,
      default() {
        return [];
      },
    },
    nature_postes: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  data() {
    return {
      selectedChantiers: [],
      form: null,
      // VueEditorToolbar,
    };
  },
  components: {
    DatePicker,
    // VueEditor,
  },

  methods: {
    /**
     * Modal note
     */

    init() {
      this.form = this.propForm;
    },
    submit() {
      if (!this.form.all && this.selectedChantiers.length > 0) {
        this.form.chantiers = this.selectedChantiers.map((c) => c.uuid);
      }
      this.$emit('submit', this.form);
    },
    list() {
      this.$emit('goList');
    },
  },
  computed: {
    emps() {
      return this.employes.filter((e) => e.uuid !== this.form.remplacant);
    },
    remps() {
      return this.employes.filter((e) => e.uuid !== this.form.employe);
    },
  },
  mounted() {
    this.init();
  },
};
</script>

<style scoped></style>
